import './bootstrap';

import * as Sentry from "@sentry/browser";

// Access environment variables using import.meta.env
const sentryDsn = import.meta.env.VITE_SENTRY_DSN || '';
const sentryEnv = import.meta.env.VITE_SENTRY_ENV || 'local';
const sentryRel = import.meta.env.VITE_SENTRY_REL || 'local@v0.0.0';

Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnv,
    release: sentryRel,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    enabled: sentryEnv !== 'local',
    // Session Tracing
    tracesSampleRate: sentryEnv !== 'prod' ? 1.0 : 0.2, // we collect all traces for dev and staging
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
